import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-conversion',
  templateUrl: './conversion.component.html',
  styleUrls: ['./conversion.component.scss'],
  animations: [
    trigger('slideLeftIn', [
      state('invisible', style({ opacity: 0, transform: 'translateX(104%)' })),
      state('visible', style({ opacity: 1, transform: 'translateX(0)' })),
      transition('invisible => visible', animate('0.5s ease-out')),
    ]),
  ],
})
export class ConversionComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('conversionContainer', { static: true })
  conversionContainer!: ElementRef;
  @ViewChild('container', { static: true }) container!: ElementRef;
  screenWidth!: number;
  animationState = 'invisible';
  openFeatureIndex: number | null = 0;
  autoplayIntervalId: any;
  progressUpdateId: any;
  progressWidth = 0;
  autoplayDuration = 7000;
  activeIndex = 0;

  features = this.translate.instant('home_conversion.features');

  selectedFeature: any;

  constructor(private translate: TranslateService) {
    this.selectedFeature = this.features[0];
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.screenWidth = window.innerWidth;
  }

  onAccordionTabChange(index: number | number[]) {
    this.openFeatureIndex = index as number;
    this.selectedFeature = this.features[index as number];

    const startTime = performance.now();
    this.resetProgress();
    this.updateProgress(startTime);

    const imagesVideo = this.conversionContainer.nativeElement.querySelector(
      '.screenshot-container video'
    ) as HTMLVideoElement;

    imagesVideo.style.transform = '';
    imagesVideo.style.transform = 'translateX(0)';
    const block = this.conversionContainer.nativeElement.querySelector(
      '.conversion__block[data-feature-skin="' + index + '"]'
    );

    if (block !== null) {
      imagesVideo.setAttribute(
        'poster',
        block.getAttribute('data-poster') ?? ''
      );
      imagesVideo.src = block.getAttribute('data-video') ?? '';
    }
  }

  ngOnInit() {
    this.screenWidth = window.innerWidth;
    this.startAutoplay();
  }

  ngOnDestroy() {
    this.stopAutoplay();
  }

  ngAfterViewInit() {
    if (this.container === null) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && this.screenWidth >= 1080) {
            this.animationState = 'visible';
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    observer.observe(this.container.nativeElement);
  }

  startAutoplay() {
    this.nextFeature();
    this.autoplayIntervalId = setInterval(() => {
      this.nextFeature();
    }, this.autoplayDuration);
  }

  stopAutoplay() {
    if (this.autoplayIntervalId) {
      clearInterval(this.autoplayIntervalId);
    }
    if (this.progressUpdateId) {
      cancelAnimationFrame(this.progressUpdateId);
    }
  }

  nextFeature() {
    this.activeIndex =
      this.openFeatureIndex !== null ? this.openFeatureIndex + 1 : 0;
    if (this.activeIndex >= this.features.length) {
      this.activeIndex = 0;
    }
    this.onAccordionTabChange(this.activeIndex);
    const startTime = performance.now();
    this.resetProgress();
    this.updateProgress(startTime);
  }

  resetProgress() {
    this.progressWidth = 0;
    if (this.progressUpdateId) {
      cancelAnimationFrame(this.progressUpdateId);
    }
  }

  updateProgress(startTime: DOMHighResTimeStamp) {
    const currentTime = performance.now();
    const elapsedTime = currentTime - startTime;
    this.progressWidth = (elapsedTime / this.autoplayDuration) * 100;

    if (elapsedTime < this.autoplayDuration) {
      this.progressUpdateId = requestAnimationFrame((timestamp) =>
        this.updateProgress(startTime)
      );
    } else {
      this.progressWidth = 100;
    }
  }
}
